import { render, staticRenderFns } from "./one_image_one_label.vue?vue&type=template&id=6fc59028&"
import script from "./one_image_one_label.vue?vue&type=script&lang=js&"
export * from "./one_image_one_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports